<template>
    <div v-if="renderComponent" class="full-email-editor-container">
        <EmailEditor
            class="b-email-editor"
            style=" display: block;     
            background: #000;
            border: none;       
            height: 72vh;
            "
            :appearance="appearance"
            :min-height="minHeight"
            :project-id="projectId"
            :editor-id="editorId"
            :locale="locale"
            :tools="tools"
            :options="options"
            ref="emailEditor"
            v-on:load="editorLoaded"
            v-on:ready="prepareEditor"
        />

        <v-file-input
            v-show="false"
            ref="fileInput"
            color="secondary"
            outlined
            dense
            @change="onFileSelected"
        ></v-file-input>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { EmailEditor } from "vue-email-editor";
import html2canvas from "html2canvas";
import { toJpeg, toBlob } from "html-to-image";
import { getBase64ImageFromUrl, sleepUntil } from "@/utils/helpers";

export default {
    name: "BEmailEditor",

    props: {
        design: {
            type: Object
        },
        resetThumbnail: {
            type: Boolean,
            default: true
        }
    },

    components: {
        EmailEditor
    },
    data() {
        return {
            minHeight: "100%",
            tools: {
                video: {
                    enabled: true
                },
                social: {
                    enabled: true
                }
            },
            mailData: {},
            options: {
                tools: {
                    video: {
                        enabled: true
                    },
                    social: {
                        enabled: true
                    }
                }
            },
            appearance: {
                theme: "dark",
                panels: {
                    tools: {
                        dock: "right"
                    }
                }
            },
            renderComponent: true,
            uploadDone: () => {},
            imageData: {
                error: "",
                success: false,
                image: null,
                url: "",
                image_file: null
            },
            errorMessages: {
                imageInvalid: {
                    el: "Μη έγκυρη εικόνα",
                    en: "Invalid image",
                    it: "Immagine non valido"
                },
                imageFailed: {
                    el: "Αποτυχία μεταφόρτωσης εικόνας",
                    en: "Failed to upload image",
                    it: "Impossibile caricare l'immagine"
                }
            },
            thumbnail: null,
            images: [],
            editorIsReady: false,
            themeIsReady: true
        };
    },

    computed: {
        ...mapState("loyaltyPanel/campaigns/newCampaign", [
            "notificationVariables"
        ]),

        lang() {
            return this.$route.params.lang;
        },
        projectId() {
            return Number(localStorage.getItem("storeId")) || 0;
        },
        editorId() {
            return (
                this.projectId +
                (this.mailData?.design?.body?.id ||
                    this.design?.body?.id ||
                    "0")
            );
        },

        locale() {
            if (this.lang == "el") return "el-GR";
            if (this.lang == "it") return "it-IT";
            return "en-GB";
        },

        mentionableItems() {
            return this.notificationVariables.map(e => ({
                value: `{{${e}}}`,
                name: e
            }));
        }
    },

    methods: {
        ...mapMutations(["setNotification"]),
        ...mapActions("loyaltyPanel/campaigns/newCampaign", [
            "uploadImage",
            "getNotificationVariables"
        ]),
        editorLoaded() {
            this.$refs.emailEditor.editor.setMergeTags(this.mentionableItems);
        },

        prepareEditor() {
            this.$refs.emailEditor?.editor.registerCallback(
                "selectImage",
                this.selectImage
            );
            this.$refs.emailEditor?.editor.registerCallback(
                "rerender",
                this.forceRerender
            );
            this.$refs.emailEditor?.editor.addEventListener(
                "design:updated",
                this.getNewData
            );
            this.editorIsReady = true;
            if (this.design) {
                this.$nextTick(() => {
                    this.$refs.emailEditor?.editor.loadDesign(this.design);
                });
            } else {
                this.$nextTick(() => {
                    this.$refs.emailEditor?.editor.loadBlank({
                        backgroundColor: "#e7e7e7"
                    });
                });
            }
        },

        saveDesign() {
            this.$refs.emailEditor?.editor.saveDesign(design => {});
        },
        openFileInput() {
            this.$refs.fileInput.$children[0].$el.click();
        },
        async uploadImageFile(imageFile) {
            this.image = null;
            this.imageData.image_file = imageFile;
            let data = await this.uploadImage({
                image: imageFile,
                type: "mail",
                b64: true
            });
            if (data) {
                this.imageData = { ...this.imageData, ...data };
            }
            if (this.validateImage()) {
                this.uploadDone({ url: this.imageData.url });
                const imageReader = new FileReader();
                imageReader.readAsDataURL(this.imageData.image_file);
                imageReader.onload = async e => {
                    this.imageData.image = e.target.result;
                };
                this.images.push({ ...this.imageData });
            }
            await this.$emit("update", {
                ...this.mailData,
                thumbnail: this.thumbnail,
                isReady: false
            });
            this.themeIsReady = false;
            return data;
        },

        async onFileSelected(event) {
            if (event) {
                await this.uploadImageFile(event);
            }
        },
        async getNewData() {
            await this.$refs.emailEditor?.editor.exportHtml(data => {
                this.mailData = data;

                return data;
            });
        },
        async selectImage(data, done) {
            this.openFileInput();
            this.uploadDone = done;
        },

        async uploadEditorImage(file, done) {
            let data = await this.uploadImageFile(file);
            done({ progress: 100, url: data.url });
        },
        async forceRerender() {
            this.renderComponent = false;
            await this.$nextTick();
            this.renderComponent = true;
        },

        validateImage() {
            this.imageData.error = "";
            this.imageData.success = false;
            if (
                this.imageData.url.includes("https://roadcube") &&
                this.imageData.url.includes("amazonaws.com/")
            ) {
                this.imageData.success = true;
            }
            if (!this.imageData.image_file || !this.imageData.url) {
                this.imageData.error = this.errorMessages.imageFailed[
                    this.lang
                ];
                this.imageData.success = false;
            } else if (
                this.imageData.image_file &&
                !this.isValidImage(this.imageData.image_file)
            ) {
                this.imageData.error = this.errorMessages.imageInvalid[
                    this.lang
                ];
                this.imageData.success = false;
            }

            if (this.imageData.error) {
                this.setNotification({
                    show: true,
                    type: "error",
                    text: this.imageData.error
                });
            }
            return this.imageData.success;
        },

        isValidImage(img) {
            try {
                return ["image/jpg", "image/jpeg", "image/png"].includes(
                    img?.type || ""
                );
            } catch (e) {
                return false;
            }
        },

        async getThumbnail() {
            this.thumbnail = null;
            var elemDiv = document.createElement("div");
            elemDiv.style.maxWidth = "750px";
            elemDiv.style.paddingTop = "64px";
            elemDiv.style.paddingBottom = "64px";
            let divHtml = this.mailData.html;

            try {
                let UrlRegexp = /src="(http[s]):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])"/g;
                let imageUrls = this.mailData.html.match(UrlRegexp) || [];
                for (let url of imageUrls) {
                    if (url.includes("image")) {
                        url = url.split(/[""]/)[1];
                        let htmlAr = divHtml.split(url);
                        let imageData = this.images.find(x => x.url == url);
                        if (!imageData?.b64) {
                            imageData = {};
                            imageData.b64 = await getBase64ImageFromUrl(url);
                        }
                        let urlBase64 = imageData.b64;
                        let html64 = [htmlAr[0], urlBase64, htmlAr[1]].join("");
                        divHtml = html64;
                    }
                }
                elemDiv.innerHTML = divHtml;

                document.body.appendChild(elemDiv);
                const canvas = await html2canvas(elemDiv, {
                    allowTaint: true,
                    useCORS: true
                    //   height: 600,
                    //   width: 800,
                });

                document.body.appendChild(canvas);
                let img = await toJpeg(canvas, { quality: 0.5 });
                let blob = await toBlob(canvas, { quality: 0.5 });

                elemDiv.remove();
                canvas.remove();

                return { img, blob };
            } catch (error) {
                console.log("getThumbnail:", error);
            }
        },

        async setThumbnail() {
            if (this.resetThumbnail || !this.thumbnail) {
                this.thumbnail = await this.getThumbnail();
            }
            this.themeIsReady = true;
        }
    },

    watch: {
        mailData: {
            async handler(val) {
                this.themeIsReady = false;

                await this.$emit("update", { ...val, isReady: false });

                await this.setThumbnail();
                let data = {
                    ...val,
                    thumbnail: this.thumbnail,
                    isReady: this.themeIsReady
                };
                await this.$emit("update", data);
                this.themeIsReady = true;
            },
            deep: true
        },

        locale: {
            async handler(val) {
                await this.forceRerender();
                this.$nextTick(() => {
                    if (
                        this.$refs?.emailEditor?.editor &&
                        this.mailData?.design
                    ) {
                        this.$refs.emailEditor?.editor.loadDesign(
                            this.mailData.design
                        );
                    }
                });
            },
            deep: true
        },
        design: {
            async handler(val) {
                try {
                    if (val || val === null) {
                        await this.$nextTick(async () => {
                            if (!this.editorIsReady) {
                                await sleepUntil(
                                    () => this.editorIsReady,
                                    300000
                                );
                            }
                            if (!this.themeIsReady) {
                                await sleepUntil(
                                    () => this.themeIsReady,
                                    300000
                                );
                            }
                            if (
                                this.$refs?.emailEditor?.editor &&
                                this.mailData
                            ) {
                                if (val === null) {
                                    await this.$refs.emailEditor.editor.loadBlank(
                                        {
                                            backgroundColor: "#e7e7e7"
                                        }
                                    );
                                } else {
                                    await this.$refs.emailEditor.editor.loadDesign(
                                        val
                                    );
                                }

                                await this.getNewData();
                            }
                        });
                    }
                } catch (error) {
                    console.log("design watcher error: " + error);
                }

                //   }
            },
            deep: true,
            immediate: true
        },

        resetThumbnail: {
            async handler(val) {
                if (val) {
                    this.themeIsReady = false;
                    await this.setThumbnail();
                    this.themeIsReady = true;
                }
            },
            deep: true
        }
    },

    created() {
        this.mailData = this.mailData || {};
    }
};
</script>

<style>
html,
body {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}

#app,
#example {
    height: 100%;
}

#example .container {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
}

#bar {
    flex: 1;
    background-color: #40b883;
    color: #fff;
    padding: 10px;
    display: flex;
    max-height: 40px;
}

#bar h1 {
    flex: 1;
    font-size: 16px;
    text-align: left;
}

#bar button {
    flex: 1;
    padding: 10px;
    margin-left: 10px;
    font-size: 14px;
    font-weight: bold;
    background-color: #000;
    color: #fff;
    border: 0px;
    max-width: 150px;
    cursor: pointer;
}
.full-email-editor-container {
    width: 100%;
}
</style>
